<template>
  <div class="doc-content">
    <div class="search-header" style="overflow: hidden;">
      <div class="search-box111">
        <Search
          @search="search"
          placeholder="请输入在您所有文章中搜索的关键词"
          :isShowHistory="true"
        ></Search>
      </div>
      <Course name="doc" />
    </div>
    <el-divider class="line"></el-divider>
    <div class="filter clear">
      <div class="filter-item fr">
        <el-dropdown :hide-on-click="false" @command="selectTime">
          <span class="time cursor">
            {{ timeText }}<i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in time"
              :command="item.name"
              :key="index"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="filter-item fl mr5">
        <el-dropdown :hide-on-click="false" @command="selectFolders">
          <span class="tag cursor">
            {{ foldersText }}<i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in folders"
              :command="item.folderId"
              :key="index"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="rowcount">
        共<span class="number" fl>{{ rowCount }}</span
        >篇文章
      </div>
    </div>
    <div class="doc-content-list" v-loading="loading">
      <div v-if="list.length > 0">
        <DocCard
          style="margin:10px"
          v-for="(item, index) in list"
          :key="index"
          :item="item"
          @reload="reload"
        ></DocCard>
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            :total="rowCount"
            :current-page="pageIndex"
            :page-size="pageSize"
            @current-change="getList"
            :hide-on-single-page="true"
          ></el-pagination>
        </div>
      </div>
      <div v-if="docnodata" class="docNoData">
        <p>您的文集中还没有保存任何文章</p>
        <p>请在编辑器保存文章后，您的所有文章将会显示</p>
        <p>于该列表，方便快速切换文章编辑</p>
        <p><img src="../../assets/image/document/docarrows.png" /></p>
      </div>
    </div>
  </div>
</template>

<script>
import DocCard from "../../components/doc/DocCard";
import { mapActions, mapState, mapMutations } from "vuex";
import Search from "../../components/share/Search";
import Course from "@/components/share/Course";
export default {
  components: { Search, DocCard, Course },
  // props: ["keyword"],
  data() {
    return {
      keyword: "",
      pageIndex: 1,
      pageSize: 20,
      rowCount: 0,
      list: [],
      docnodata: false,
      loading: false,
      foldersText: "全部文集",
      folders: [
        {
          folderId: -999,
          name: "全部文集"
        }
      ],
      folderId: -999,
      time: [
        {
          text: "UpdateTime|DESC",
          name: "最近更新"
        },
        {
          text: "Addtime|ASC",
          name: "最早创建"
        },
        {
          text: "AddTime|DESC",
          name: "最近创建"
        },
        {
          text: "UpdateTime|ASC",
          name: "最早更新"
        }
      ],
      timeText: "最近更新",
      sortColumn: "UpdateTime",
      sortType: "DESC"
    };
  },
  computed: {
    ...mapState("material", {
      docUpdate: ["docUpdate"]
    })
  },
  watch: {
    docUpdate: {
      handler(val) {
        if (val) {
          let getTinymceBox = document.getElementsByClassName(
            "doc-content-list"
          )[0];
          if (getTinymceBox) {
            this.getList(1);
            this.getFolder();
            let isUpdate = false;
            this.ASetDocUpdate(isUpdate);
          }
        }
      }
    }
  },
  methods: {
    ...mapActions("api", ["ADoc", "AFolder"]),
    ...mapMutations("material", ["ASetDocUpdate"]),
    selectFolders(folderId) {
      var result = this.folders.filter(m => m.folderId === folderId);
      this.folderId = folderId;
      this.foldersText = result[0].name;
      this.getList(1);
    },
    selectTime(timeText) {
      this.timeText = timeText;
      var result = this.time.filter(m => m.name === timeText)[0].text;
      this.sortColumn = result.split("|")[0];
      this.sortType = result.split("|")[1];
      this.getList(1);
    },
    async getList(pageIndex) {
      this.loading = true;
      this.pageIndex = pageIndex;
      var result = await this.ADoc({
        pageIndex,
        pageSize: this.pageSize,
        title: this.keyword,
        folderId: this.folderId,
        sortColumn: this.sortColumn,
        sortType: this.sortType
      });
      this.loading = false;
      if (result.errorCode === 0) {
        this.list = result.data.dataSource;
        this.rowCount = result.data.rowCount;
        if (this.rowCount <= 0) {
          this.docnodata = true;
        }
      } else {
        if (result.errorCode === 300000) {
          this.insertConfig.showLoginMessage(
            true,
            "您当前账号暂未登录，请登录账号享更多权限",
            "doc"
          );
        } else {
          this.$message({
            showClose: true,
            message: result.errorMess,
            type: "error"
          });
        }
      }
    },
    search(keyword) {
      this.keyword = keyword;
      this.getList(1);
    },
    fixHeight(newContentHeight) {
      let toolbar = document.querySelector(".el-header");
      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }
      let editorStatusBarHeight = 2;
      let realHeight =
        newContentHeight - editorToolbarHeight - editorStatusBarHeight;
      let getTinymceBox = document.getElementsByClassName(
        "doc-content-list"
      )[0];

      getTinymceBox.style.height = realHeight - 180 + "px";
    },
    async getFolder() {
      let result = await this.AFolder({ pageSize: 0 });
      if (result.errorCode === 0) {
        if (result.data.rowCount > 0) {
          result.data.dataSource.forEach(m => {
            this.folders.push(m);
          });
        }
      }
    },
    reload() {
      this.getList(this.pageIndex);
    }
  },
  mounted() {
    this.fixHeight(document.documentElement.clientHeight);
    this.getList(1);
    this.getFolder();
  },
  activated() {
    if (this.docUpdate) {
      this.fixHeight(document.documentElement.clientHeight);
      this.getList(1);
      this.getFolder();
      let isUpdate = false;
      this.ASetDocUpdate(isUpdate);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
.app-course {
  color: #216bed;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-top: 8px;
  margin-right: 3px;
}

.doc-content .page {
  .pageIndex();
}
.docNoData {
  color: #666;
  text-align: center;
  margin-top: 150px;
  p {
    margin-top: 10px;
    font-size: 14px;
    &:nth-child(1) {
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 600;
    }
    &:nth-child(4) {
      margin-top: 30px;
    }
  }
}

.doc-content .search-header {
  padding: 20px 20px;
}
.doc-content .line {
  margin: 0;
}
.doc-content .filter {
  margin: 15px 20px 8px 20px;
}
.doc-content .filter .filter-item .tag {
  font-size: 12px;
  border: 1px solid #e7ebf5;
  border-radius: 16px;
  padding: 5px 7px;
}
.doc-content .filter .filter-item .time {
  font-size: 12px;
  border: 1px solid #e7ebf5;
  border-radius: 16px;
  padding: 5px 7px;
}
.doc-content .filter .number {
  color: blue;
}
.doc-content .filter {
  font-size: 12px;
}
.doc-content .rowcount {
  line-height: 22px;
  letter-spacing: 2px;
}
.doc-content .doc-content-list {
  height: 500px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
}
//分页
.page {
  margin: 10px;
}
.search-box111 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  float: left;
  width: 360px;
  display: inline-block;
}
</style>
